<template>
  <div class="user_all">
    <div class="form">
      <div class="user_search">
        <span style="width: 200px;display: inline-block">RPC：</span>
        <el-select
          style="width: 520px"
          v-model="selectValue"
          @change="changeRpc()"
          placeholder="Please choose RPC"
        >
          <el-option
            v-for="item in options"
            :key="item.rpcUrl"
            :label="item.rpcUrl"
            :value="item.rpcUrl"
          ></el-option>
        </el-select>
      </div>
      <div class="user_search">
        <span style="width: 200px;display: inline-block">ChainId：</span>
        <el-select
          style="width: 520px"
          v-model="selectChain"
          @change="changeChain()"
          placeholder="Please choose ChainId"
        >
          <el-option v-for="item in options1" :key="item" :label="item+ '  Chain'" :value="item"></el-option>
        </el-select>
      </div>

      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">Onwer Address：</span>
        <el-input
          v-model="Address"
          type="primary"
          style="width: 520px"
          placeholder="Please enter Onwer Address"
        ></el-input>
      </div>
      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">TokenName：</span>
        <el-input
          v-model="TokenName"
          type="primary"
          style="width: 520px"
          placeholder="Please enter TokenName"
        ></el-input>
      </div>
      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">ContractAddress：</span>
        <el-input
          v-model="ContractAddress"
          type="primary"
          style="width: 520px"
          placeholder="Please enter ContractAddress"
        ></el-input>
      </div>
      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">ContractName：</span>
        <el-input
          v-model="ContractName"
          type="primary"
          style="width: 520px"
          placeholder="Please enter ContractName"
        ></el-input>
      </div>
      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">IconUrl：</span>
        <el-input
          v-model="IconUrl"
          type="primary"
          style="width: 520px"
          placeholder="Please enter IconUrl"
        ></el-input>
      </div>
      <div class="user_search" style="display: flex;align-items:center;">
        <span style="width: 200px;display: inline-block">Abi：</span>
        <el-input
          :autosize="{ minRows: 10, maxRows: 10}"
          v-model="Abi"
          type="textarea"
          style="width: 520px"
          placeholder="Please enter Abi"
        ></el-input>
      </div>
      <div class="user_search">
        <el-button style="width:300px" type="primary" @click="submit()">Submit</el-button>
      </div>
    </div>
    <div class="img">
      <p>Example：</p>
      <img src="@/assets/images/Example.png" />
    </div>
  </div>
</template>

<script>
import { RegistrationContract } from "../../../api/interface";
export default {
  name: "User",
  components: {},
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      isResponse: false,
      selectValue: "",
      options: [
        {
          rpcUrl: "test.thinkiumrpc.net"
        },
        {
          rpcUrl: "proxy.thinkiumrpc.net"
        }
      ],
      selectChain: "",
      Address: "",
      TokenName: "",
      ContractAddress: "",
      ContractName: "",
      Abi: "",
      IconUrl: "",
      options1: [1, 2, 103],
      inputValue: "",
      searchValue: "",
      dialogVisible: false,
      userName: "",
      privateKey: "",
      tableVisible: false,
      viewObj: {}
    };
  },
  methods: {
    changeRpc() {
      console.log("RPC", this.selectValue);
    },
    changeChain() {
      console.log("ChainId", this.selectChain);
    },
    submit() {
      //输入为空提示
      if (!this.Address.trim()) {
        this.$message.warning("Please enter Onwer Address");
        return;
      }
      if (!this.ContractName.trim()) {
        this.$message.warning("Please enter ContractName");
        return;
      }
      if (!this.ContractAddress.trim()) {
        this.$message.warning("Please enter ContractAddress");
        return;
      }
      if (!this.TokenName.trim()) {
        this.$message.warning("Please enter TokenName");
        return;
      }
      if (!this.Abi.trim()) {
        this.$message.warning("Please enter Abi");
        return;
      }
      if (!this.IconUrl.trim()) {
        this.$message.warning("Please enter IconUrl");
        return;
      }
      //地址输入错时提示
      if (!this.is0xAddress(this.Address.trim()) &&!this.isTHAddress(this.Address.trim())) {
        this.$message({
          type: "error",
          message: "Please enter the correct Onwer Address"
        });
      }
      if (!this.is0xAddress(this.ContractAddress.trim()) &&!this.isTHAddress(this.ContractAddress.trim())) {
        this.$message({
          type: "error",
          message: "Please enter the correct ContractAddress"
        });
      }

      let data = {
        chainId: this.selectChain,
        rpcUrl: this.selectValue,
        contractAddress: this.is0xTH(this.ContractAddress),
        contractName: this.ContractName,
        abi: this.Abi,
        address: this.is0xTH(this.Address),
        tokenName: this.TokenName,
        iconUrl: this.IconUrl
      };
      RegistrationContract(data).then(res => {
        console.log("注册合约", res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      }).catch(err =>{
          console.log("err",err)
          if (err.code == 601) {
          this.$message({
            type: "error",
            message: err.msg
          });
          }else{
               this.$message({
            type: "error",
            message: err.msg
          });
          }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.privateKey = "";
      this.userName = "";
    },
    currentPageChange(e) {
      this.currentPage = e;
      this.getTableData(this.searchValue, this.currentPage, 0);
    },
  
    handleClick(val) {
      this.viewObj = val;
      this.tableVisible = true;
    }
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.selectValue = this.options[0].rpcUrl;
    this.selectChain = this.options1[0];
    // this.isTHAddress("1111")
  }
};
</script>
<style scoped lang="scss">
.user_all {
  margin: 0 auto;
  margin-top: 40px;
  //   padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  //   align-items: center;
}
.img {
  padding-top: 20px;
  padding-left: 20px;
  margin-left: 100px;
  border: 1px solid #dddddd;
  img {
    width: 80%;
  }
}
.user_search {
  display: flex;
  justify-content: center;
  align-items: center;
}

.user_search {
  margin-bottom: 30px;
}
.view_detail {
  width: 100%;
  .view_detail_item {
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    span {
      display: block;
      margin-right: 20px;
    }
  }
}
</style>
